import { IntlShape } from 'react-intl';

export const required = (value: string, intl?: IntlShape): string | undefined => {
  if (value == null || value === '') {
    if (intl && typeof intl.formatMessage === 'function') {
      return intl.formatMessage({ id: 'required' });
    }
    return 'Required';
  }
  return undefined;
};

export const moreThanZero = (value: string, intl?: IntlShape): string | undefined => {
  const number = parseFloat(value);
  if (number <= 0) {
    if (intl && typeof intl.formatMessage === 'function') {
      return intl.formatMessage({ id: 'numberMustBeMoreThanZero' });
    }
    return 'Number must be more than zero';
  }
  return undefined;
};

export const email = (value: string): string | undefined => {
  const regex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/i;
  return regex.test(value) ? undefined : 'Invalid email';
};

export const containsSymbols = (value: string, intl?: IntlShape): string | undefined => {
  if (!/[!@#$%^&*()_+{}[\]:;<>,.?~-]/.test(value)) {
    if (intl && typeof intl.formatMessage === 'function') {
      return intl.formatMessage({ id: 'pwdMustContainSymbols' });
    }
    return 'Password must contain symbols';
  }
  return undefined;
};

export const containsNumbers = (value: string, intl?: IntlShape): string | undefined => {
  if (!/\d/.test(value)) {
    if (intl && typeof intl.formatMessage === 'function') {
      return intl.formatMessage({ id: 'pwdMustContainNumbers' });
    }
    return 'Password must contain numbers';
  }
  return undefined;
};

export const containsCaps = (value: string, intl?: IntlShape): string | undefined => {
  if (!/[A-Z]/.test(value)) {
    if (intl && typeof intl.formatMessage === 'function') {
      return intl.formatMessage({ id: 'pwdMustContainCaps' });
    }
    return 'Password must contain capital letters';
  }
  return undefined;
};

export const matchesPwdLength = (value: string, intl?: IntlShape): string | undefined => {
  if (!/^.{8,24}$/.test(value)) {
    if (intl && typeof intl.formatMessage === 'function') {
      return intl.formatMessage({ id: 'pwdLengthNotCorrect' });
    }
    return 'Password length not correct';
  }
  return undefined;
};
